interface IProps {
  className?: string
  fill?: string
  width?: number
  height?: number
}
const FilterHeaderHash = ({className, fill = "#888", width = 9, height = 10}: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 9 10"
      fill="none"
    >
      <path className={className} fill={fill} d="M7.90942 0H1.09059C0.221002 0 -0.297671 0.957774 0.184687 1.67282L3.04553 5.41372C3.284 5.76722 3.41125 6.18256 3.41125 6.60741V9.46093C3.41125 9.94023 3.99762 10.1803 4.34056 9.84135L5.42931 8.76537C5.5314 8.66448 5.58875 8.52764 5.58875 8.38496V6.60741C5.58875 6.18256 5.716 5.76722 5.95447 5.41372L8.81531 1.67282C9.29767 0.957774 8.779 0 7.90942 0Z"/>
    </svg>
  )
}

export default FilterHeaderHash;
